export const SET_COURSES = 'SET_COURSES';
export const SET_CAMPUSES = 'SET_CAMPUSES';
export const SET_SPORTS = 'SET_SPORTS';
export const SET_COURSE = 'SET_COURSE';
export const RESET_COURSE = 'RESET_COURSE';
export const SET_COURSES_FILTER = 'SET_COURSES_FILTER';
export const SET_SUBSCRIPTION_LOADING = 'SET_SUBSCRIPTION_LOADING';
export const RESET_PENDING_SUBSCRIPTION = 'RESET_PENDING_SUBSCRIPTION';
export const SET_SUBSCRIPTIONS = 'SET_SUBSCRIPTIONS';
export const SET_SUBSCRIPTION = 'SET_SUBSCRIPTION';
export const SET_PENDING_SUBSCRIPTION = 'SET_PENDING_SUBSCRIPTION';
export const SET_CURRENT_STUDENT = 'SET_CURRENT_STUDENT';
export const SET_ALERT = 'SET_ALERT';
export const SET_PROGRAMS = 'SET_PROGRAMS';
export const SET_SETTINGS = 'SET_SETTINGS';
export const SET_SIGN_UP_FORM = 'SET_SIGN_UP_FORM';
export const SET_SUBSCRIPTIONS_FILTER = 'SET_SUBSCRIPTIONS_FILTER';
